module.exports = __webpack_public_path__ + "media/images/common/rakuten-4e93f8e137f29d8e68d44d75ce0704e4.png";